import React from 'react';
import { Skeleton } from '@components/ui/skeleton';
import cn from 'classnames';
const FAQLoader: React.FC = () => {
  const skeletonItems = Array.from({
    length: 5
  });
  return <div className="py-16 lg:py-20 px-0 max-w-5xl mx-auto space-y-4" data-sentry-component="FAQLoader" data-sentry-source-file="faq-loader.tsx">
      <div className="space-y-4">
        {skeletonItems.map((_, index) => <div key={index} className={cn('rounded-md bg-gray-200 dark:bg-neutral-700 animate-pulse')}>
            <div className="flex items-center justify-between p-5 md:p-6 cursor-pointer">
              <Skeleton className="h-6 w-3/4" aria-label="Loading question" />
              <Skeleton className="h-6 w-6" aria-label="Loading toggle icon" />
            </div>
            <div className="p-5 md:p-6 hidden"> 
              <Skeleton className="h-4 w-full mb-2" aria-label="Loading answer line 1" />
              <Skeleton className="h-4 w-5/6 mb-2" aria-label="Loading answer line 2" />
              <Skeleton className="h-4 w-4/6" aria-label="Loading answer line 3" />
            </div>
          </div>)}
      </div>
    </div>;
};
export default React.memo(FAQLoader);